import styled from 'styled-components';
import { ColorAddiGrayDarken3 } from '@addi/foundation/dist/web/colors';
import { DSMappedIcon } from './dsIcon';
export const DSIcon = styled(DSMappedIcon) `
    width: 20px;
    height: 20px;

    path {
        fill: ${ColorAddiGrayDarken3};
    }
`;
//# sourceMappingURL=dsIcon.styled.js.map